import { Directive, ElementRef, HostListener } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';

@Directive({
  selector: '[commaSeparator]'
})
export class CommaSeparatorDirective implements ControlValueAccessor {
  
  constructor(private ref: ElementRef) { }
  
  writeValue(obj: any): void {
    throw new Error('Method not implemented.');
  }
  registerOnChange(fn: any): void {
    throw new Error('Method not implemented.');
  }
  registerOnTouched(fn: any): void {
    throw new Error('Method not implemented.');
  }
  setDisabledState?(isDisabled: boolean): void {
    throw new Error('Method not implemented.');
  }

  @HostListener('input', ['$event'])
  public onInput(event: any): void {
    
    let val = this.ref.nativeElement.value;

    // Format as needed

    let correctFormat = val.toString().replace(/\./g, ',');
 
    correctFormat = this.numbermask(correctFormat);

    
    // set valid pattern
    this.ref.nativeElement.pattern = "[0-9]+([\.,][0-9]+)?";
    this.ref.nativeElement.step = "0.01";
    this.ref.nativeElement.lang = "es";

    // Set value
    this.ref.nativeElement.value = correctFormat;
  }

  
  @HostListener('focus', ['$event'])
  public focus(event: any): void {
    
    let val = this.ref.nativeElement.value;
    if (val==='0'){
      val='';
    }

    this.ref.nativeElement.value=val;
  }


  numbermask(str){//solo letras y numeros y los cácteres especiales que se requieran
    let encontrado=false;
    let duplicado=false;
    var out = '';

    //Mascara para sólo añadir los caracteres permitidos, solo letras y numeros y los',' (No admitimos '.')

    //Se añaden las letras, números y carácteres válidos
    var filtro = '1234567890,';//Caracteres validos
	
    for (var i=0; i<str.length; i++){
       if (filtro.indexOf(str.charAt(i)) != -1) 
       { 
         if(str.charAt(i)===',') {//Separador decimal
          if(!encontrado){
            encontrado=true
          } else{
            duplicado=true
          }
      
        }
        if (!duplicado){ //duplicado indica que se ha puesto más de una vez el caracter ',' decimal.
          if((i>0) || (i==0)&&(str.charAt(i)!=='0')){
           out += str.charAt(i);
          }
        }
        duplicado=false
      }
    }

// SE QUITAN MÁS DE 2 DECIMALES 
      let array=out.split(',') //Separador decimal
     
      let substring='';
      if(array.length>1){
        substring=array[1].substring(0,2);
        if (array[0].length===0){ //para evitar el valor ',55' le ponemos un 0 delante
            array[0]='0';
        }
        out=array[0]+','+substring;  // ',' es Separador decimal
      }
      else if(array.length===1){   //en caso de tener sólo un decimal, lo dejamo tal cual  
          out=array[0]
      } 

    return out;
}

}
